import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles(theme => ({
  dialogPaper: {
    borderRadius: 16,
    overflow: "hidden",
  },
  dialogTitle: {
    backgroundColor: "#092147",
    padding: theme.spacing(2, 3),
    color: "#fff",
  },
  titleRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  deviceChipHeader: {
    backgroundColor: "rgba(255,255,255,0.15)",
    color: "#fff",
    fontWeight: 600,
    fontSize: "0.75rem",
  },
  filterBar: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
    padding: theme.spacing(2, 3),
    backgroundColor: "#f8fafc",
    borderBottom: "1px solid #e2e8f0",
  },
  filterRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    flexWrap: "wrap",
  },
  searchRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    flexWrap: "wrap",
    paddingTop: theme.spacing(1),
    borderTop: "1px solid #e2e8f0",
  },
  dateField: {
    backgroundColor: "#fff",
    borderRadius: 8,
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
    },
  },
  searchField: {
    flex: 1,
    minWidth: 220,
    backgroundColor: "#fff",
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      fontSize: "0.85rem",
    },
  },

  exportBtn: {
    textTransform: "none",
    borderRadius: 8,
    fontWeight: 600,
    fontSize: "0.82rem",
    whiteSpace: "nowrap",
    borderColor: "#2563eb",
    color: "#2563eb",
    "&:hover": {
      backgroundColor: "#eff6ff",
      borderColor: "#1d4ed8",
    },
  },
  statsRow: {
    display: "flex",
    gap: theme.spacing(2),
    padding: theme.spacing(1.5, 3),
    backgroundColor: "#fff",
    borderBottom: "1px solid #e2e8f0",
    alignItems: "center",
    flexWrap: "wrap",
  },
  statChip: {
    fontWeight: 600,
    fontSize: "0.75rem",
  },
  tableContainer: {
    maxHeight: 420,
    overflow: "auto",
  },
  tableHead: {
    backgroundColor: "#f1f5f9",
    "& th": {
      fontWeight: 700,
      color: "#374151",
      fontSize: "0.8rem",
      whiteSpace: "nowrap",
      padding: theme.spacing(1, 2),
      borderBottom: "2px solid #e2e8f0",
    },
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "#f8fafc",
    },
    "& td": {
      fontSize: "0.82rem",
      padding: theme.spacing(1, 2),
      borderBottom: "1px solid #f1f5f9",
    },
  },
  badgeSuccess: {
    backgroundColor: "#dcfce7",
    color: "#166534",
    borderRadius: 20,
    padding: "2px 10px",
    fontSize: "0.72rem",
    fontWeight: 600,
    display: "inline-block",
  },
  badgeError: {
    backgroundColor: "#fee2e2",
    color: "#991b1b",
    borderRadius: 20,
    padding: "2px 10px",
    fontSize: "0.72rem",
    fontWeight: 600,
    display: "inline-block",
  },
  badgeDefault: {
    backgroundColor: "#f1f5f9",
    color: "#475569",
    borderRadius: 20,
    padding: "2px 10px",
    fontSize: "0.72rem",
    fontWeight: 600,
    display: "inline-block",
  },
  loadingBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(6),
    gap: theme.spacing(2),
  },
  emptyBox: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(5),
    color: "#94a3b8",
  },
  errorBox: {
    margin: theme.spacing(2, 3),
    padding: theme.spacing(2),
    backgroundColor: "#fef2f2",
    border: "1px solid #fecaca",
    borderRadius: 8,
    color: "#991b1b",
  },
  dialogActions: {
    padding: theme.spacing(2, 3),
    backgroundColor: "#f8fafc",
    borderTop: "1px solid #e2e8f0",
    justifyContent: "space-between",
  },
  paginationRoot: {
    borderTop: "none",
  },
  iconBtn: {
    color: "#fff",
  },
  searchBtn: {
    textTransform: "none",
    fontWeight: 700,
    borderRadius: 8,
    padding: theme.spacing(1, 3),
  },
  portraitCell: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  avatarSmall: {
    width: 32,
    height: 32,
    fontSize: "0.8rem",
    backgroundColor: "#dbeafe",
    color: "#1e40af",
  },
  verifyModeChip: {
    fontSize: "0.7rem",
    height: 22,
  },
}))

export default useStyles
